import { colorGreyD1 } from "../../styles/manualVars";

const TrackMasterIcon = () => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7552 19.9755C18.6253 19.9755 23.2604 15.8592 23.2604 10.9623C23.2604 6.06546 18.6253 1.94913 12.7552 1.94913C6.88509 1.94913 2.25 6.06546 2.25 10.9623C2.25 15.8592 6.88509 19.9755 12.7552 19.9755ZM12 21.4973C5.37258 21.4973 0 16.7976 0 11.0001C0 5.20269 5.37258 0.50293 12 0.50293C18.6274 0.50293 24 5.20269 24 11.0001C24 16.7976 18.6274 21.4973 12 21.4973Z"
      fill={colorGreyD1}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9636 8.11602H8.66368L7.27978 16.0966H5.38184L6.76575 8.11602H4.49878L4.78215 6.50146H11.247L10.9636 8.11602ZM14.069 6.50146L14.6291 13.4012L17.5749 6.50146H20.0659L18.3986 16.0966H16.5007L16.962 13.4408L17.7924 9.6515L14.8532 16.0966H13.5681L12.8432 9.43403L12.2963 13.566L11.8613 16.0966H9.96998L11.6307 6.50146H14.069Z"
      fill={colorGreyD1}
    />
  </svg>
);

export default TrackMasterIcon;
